import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import defaultFormValues from "../utils/defaultFormValues";
const useJourneySearchFormContext = () => {
  const { resetField: _resetField, setValue, ...rest } = useFormContext();
  const clearFormField = useCallback((fieldName) => {
    setValue(fieldName, defaultFormValues[fieldName]);
  }, [setValue]);
  return {
    setValue,
    clearFormField,
    ...rest
  };
};
var useJourneySearchFormContext_default = useJourneySearchFormContext;
export {
  useJourneySearchFormContext_default as default
};
